import PropTypes from 'prop-types'
import { useEffect } from 'react'
import useViewport from '../../../common/hooks/useViewport'
import { Element } from '../../../common/html/element'
import { PopupAction } from '../../../common/popup/PopupAction'
import { UseScoreRange } from '../../score/common/hooks/useScoreRange'
import Content from './Content'
import classes from './index.module.scss'

export const PopupCompanyList = ({
  isShowPopup,
  setIsShowPopup,
  isLoading,
  getListCompany,
  hiddenSelectAll,
  ...other
}) => {
  const { width, height } = useViewport()
  const { thunk, dependencies } = getListCompany()
  const { loading: isScoreRangeLoading } = UseScoreRange()

  const closePopup = () => {
    setIsShowPopup(false)
  }

  useEffect(() => {
    thunk()
  }, [...dependencies])

  return (
    <PopupAction
      isShow={isShowPopup}
      title="portfolio.common.LIST_OF_COMPANIES"
      handleClose={closePopup}
      appendStyle={{
        width: 0.95 * width,
        minWidth: 900,
        maxWidth: 1200,
        padding: '20px 20px 14px',
        backgroundColor: '#F3F3F3',
        borderRadius: '4px',
      }}
    >
      <div
        className="positionRelative"
        style={{ height: 0.8 * height, maxHeight: 700, marginBottom: -7 }}
      >
        <Element
          className={classes.table}
          style={{ backgroundColor: '#FFFFFF' }}
        >
          <Content
            isLoading={isLoading || isScoreRangeLoading}
            hiddenSelectAll={hiddenSelectAll}
            {...other}
          />
        </Element>
      </div>
    </PopupAction>
  )
}

PopupCompanyList.propTypes = {
  isShowPopup: PropTypes.bool,
  setIsShowPopup: PropTypes.func,
  isLoading: PropTypes.bool,
  hiddenSelectAll: PropTypes.bool,
}
